module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/MapControls-d89ec6547d80c5a3ea331f668204ccb9.jpg";